import queryString from 'query-string';
import http from '../httpConfig';
import { List, AddEditApi } from '../interfaces/customer.interface';
import { API_ENDPOINTS } from '../utils/apiConstant';
import { buildPagingResponse } from '../utils/methods';

const list = (payload: List) => {
  const { searchText, status, city, ...others } = payload;
  const paging = buildPagingResponse(others);
  const url = `${API_ENDPOINTS.listCustomers}?${queryString.stringify(paging)}`;
  return http.post(url, { search: searchText, is_active: status, billing_city: city });
};

const lookup = (payload: any) => {
  const url = `${API_ENDPOINTS.lookupCustomers}?${queryString.stringify({ search: payload.searchText || '', is_active: payload.is_active })}`;
  return http.get(url);
};

const add = (payload: AddEditApi) => {
  return http.post(API_ENDPOINTS.customers, payload);
};

const edit = (id: string, payload: AddEditApi) => {
  return http.put(`${API_ENDPOINTS.customers}/${id}`, payload);
};

const get = (id: string) => {
  return http.get(`${API_ENDPOINTS.customers}/${id}`);
};

const kpis = () => {
  return http.get(API_ENDPOINTS.customerKpis);
};

const customerProperties = (payload:List & {id:string} ) => {
  const { id, ...others } = payload;
  const paging = buildPagingResponse(others);
  const url = `${API_ENDPOINTS.customerProperties}?${queryString.stringify(paging)}`;
  return http.post(url, { customer_id: id });
};

const CustomerService = {
  list,
  lookup,
  add,
  edit,
  get,
  kpis,
  customerProperties
};

export default CustomerService;


